var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send;

  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'RoleMaster');

    var $nesting = [self].concat($parent_nesting), $RoleMaster_initialize$1, $RoleMaster_gameName$2, $RoleMaster_gameType$3, $RoleMaster_getHelpMessage$4;

    
    
    Opal.def(self, '$initialize', $RoleMaster_initialize$1 = function $$initialize() {
      var $iter = $RoleMaster_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $RoleMaster_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $RoleMaster_initialize$1, false), $zuper, $iter);
      self.upplerRollThreshold = 96;
      return (self.unlimitedRollDiceType = 100);
    }, $RoleMaster_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $RoleMaster_gameName$2 = function $$gameName() {
      var self = this;

      return "ロールマスター"
    }, $RoleMaster_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $RoleMaster_gameType$3 = function $$gameType() {
      var self = this;

      return "RoleMaster"
    }, $RoleMaster_gameType$3.$$arity = 0);
    return (Opal.def(self, '$getHelpMessage', $RoleMaster_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "上方無限ロール(xUn)の境界値を96にセットします。\n"
    }, $RoleMaster_getHelpMessage$4.$$arity = 0), nil) && 'getHelpMessage';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
